var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardNext = function SvgCardNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 40,
    viewBox: "0 0 56.957 49",
    role: "presentation"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f9f9f9",
    d: "m32.466 0-3.145 3.146 19.123 19.11H0v4.475h48.444L29.321 45.854 32.466 49l24.49-24.506Z"
  })));
};
export default SvgCardNext;